import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteMarketingFlow } from "./deleteMarketingFlow.request";

const useDeleteMarketingFlow = (
  options?: MutationOptions<
    { ok: boolean },
    ApiServiceError<ApiError>,
    string
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestDeleteMarketingFlow,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useDeleteMarketingFlow;
